import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import {
  DiscardedProposals,
  RecordMeta,
} from "../TakenActions/ResolutionOrigin";

/**
 * Lo que la persona elegida ya tiene registrado, de solo lectura. Las propuestas
 * que otro equipo ya resolvio dejan de ofrecerse, asi que aqui es donde se ve que
 * paso con ellas y se evita repetir lo que ya se aplico.
 */
export const PersonRecords = ({
  records = [],
  actionsKey,
  anotherKey,
  options = [],
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();

  if (records.length === 0) return null;

  // Mismo criterio que la lista de registros: los previos guardan solo la llave.
  const getLabel = (item) =>
    typeof item === "object" && item?.label
      ? item.label
      : options.find((option) => option.value === item)?.label || item;

  return (
    <Box
      sx={{
        mb: 1.5,
        p: 1.5,
        border: `1px solid ${theme.palette.blueGray100.main}`,
        borderRadius: 1.5,
      }}
    >
      <Typography variant="body2" fontWeight={600} color="secondary">
        {t("Resolution.person_records_title")}
      </Typography>

      <Stack spacing={1} mt={0.75}>
        {records.map((record, idx) => (
          <Box key={record.id}>
            <RecordMeta
              record={record}
              position={idx + 1}
              total={records.length}
            />
            <Typography component="div" fontSize={12.8} lineHeight={1.4}>
              {[
                ...(record[actionsKey] || []).map(getLabel),
                ...(record.another || []).map((item) => item?.[anotherKey]),
              ]
                .filter(Boolean)
                .join("; ")}
            </Typography>
            <DiscardedProposals discarded={record.discarded} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
